module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"Kiri & Alex","short_name":"Kiri & Alex","start_url":"/","background_color":"#0000000","theme_color":"#0000000","display":"minimal-ui","icon":"src/images/icon.png","cache_busting_mode":"query","include_favicon":true,"legacy":true,"theme_color_in_head":true,"cacheDigest":"714ab684885ed6ac511d685f3a277990"},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
